module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/slider_02-3ff29132a4d8c6c27d21b9c02a5a887b.svg";